import { motion } from "framer-motion";
import { FOUNDER_IMAGE, CONTACT } from "../../data/site";

export const Founder = () => (
  <section id="story" className="bg-[#F2EBE1] py-24 md:py-32 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="col-span-12 md:col-span-5 relative"
      >
        <div className="relative rounded-md overflow-hidden aspect-[4/5]">
          <img src={FOUNDER_IMAGE} alt="Mamta Bhushan in her kitchen" className="h-full w-full object-cover" />
        </div>
        <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#B83A14] text-white rounded-md px-6 py-5 max-w-[220px]">
          <p className="font-serif text-2xl leading-tight">Mamta Bhushan</p>
          <p className="text-white/80 text-xs tracking-wide mt-1">Founder &amp; head pickle-maker</p>
        </div>
      </motion.div>

      <div className="col-span-12 md:col-span-7 md:pl-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#B83A14] font-semibold mb-5"
        >
          Her Story
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-serif text-4xl sm:text-5xl tracking-tight text-[#1E1A17] leading-tight"
        >
          It began with one jar, and a few kind neighbours.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-8 space-y-5 text-[#3D352F] text-base md:text-lg leading-relaxed"
        >
          <p>
            <span className="float-left font-serif text-6xl md:text-7xl leading-[0.8] pr-3 pt-1 text-[#B83A14]">M</span>
            amta started with nothing but a sunny terrace, her mother's masala box and a stubborn belief that homemade
            always tastes better. There was no factory, no funding, no team — just one woman filling jars at her kitchen table.
          </p>
          <p>
            When the first batch sold out, the neighbours came knocking — not to buy, but to help. One lent her jars,
            another her terrace, a third carried orders across the colony. Word travelled from balcony to balcony until a
            small home kitchen in Ghaziabad had quietly become a beloved local pickle house.
          </p>
          <p>
            Today every jar of Mamta's Kitchen still leaves that same kitchen, made in small batches by the same hands —
            a taste of a neighbourhood that decided to lift one woman up.
          </p>
        </motion.div>

        <div className="mt-9 flex items-center gap-6">
          <a
            href="#order"
            data-testid="story-order-cta"
            className="inline-flex items-center rounded-full bg-[#1E1A17] hover:bg-[#B83A14] text-white px-7 py-3.5 text-sm tracking-wide transition-colors"
          >
            Order from her kitchen
          </a>
          <span className="text-[#3D352F] text-sm">{CONTACT.city}</span>
        </div>
      </div>
    </div>
  </section>
);
